module.exports = __webpack_public_path__ + "media/fonts/UHC_Sans/UHCSans-Regular-474168c6c9f916f1e871cc39eff872fb.woff";